import React from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import VideoModal from "../VideoModal";
import { motion } from "framer-motion";
export default function Hero({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  videoBtnText,
  videoUrl,
  infoList,
  btnText,
  btnUrl,
}) {
  const words = title.split(" ").filter(Boolean);
  const wordsSubtitle=subTitle.split(" ").filter(Boolean);;
  const isVideo =
    bgUrl &&
    (bgUrl.endsWith(".mp4") ||
      bgUrl.endsWith(".webm") ||
      bgUrl.endsWith(".ogg"));

  return (
    <section className="cs_hero cs_style_1">
      <div className="cs_hero_wrap position-relative">
        {isVideo ? (
          <video
            className="hero-bg-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={bgUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <div
            className="hero-bg-image"
            style={{
              backgroundImage: `url(${bgUrl})`,
            }}
          />
        )}

        {/* Optional Dark Overlay */}
        <div className="hero-overlay"></div>

        <div className="container position-relative">
          <div className="cs_hero_text">
            <h1 className="cs_hero_title cs_fs_94 text-white">
      {words.map((word, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, filter: "blur(10px)", y: 32 }}
          animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
          transition={{
            duration: 1.6,
            delay: i * 0.4,
            ease: [0.16, 1, 0.3, 1],
          }}
          style={{ display: "inline-block" }}
        >
          {parse(word)}
        </motion.span>
      )).reduce((acc, span, i) => {
        if (i === 0) return [span];
        return [...acc, " ", span];
      }, [])}
    </h1>

            <p className="cs_hero_subtitle cs_fs_20 cs_heading_color text-white">
             {wordsSubtitle.map((word, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, filter: "blur(10px)", y: 32 }}
          animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
          transition={{
            duration: 1.6,
            delay: i * 0.4,
            ease: [0.16, 1, 0.3, 1],
          }}
          style={{ display: "inline-block" }}
        >
          {parse(word)}
        </motion.span>
      )).reduce((acc, span, i) => {
        if (i === 0) return [span];
        return [...acc, " ", span];
      }, [])}
            </p>

            <div className="cs_hero_btn_wrap text-white">
              <VideoModal
              data-aos="fade-up" data-aos-duration="100" data-aos-delay="800" data-aos-easing="ease-out-cubic"
              className="text-white"
                videoUrl={videoUrl}
                videoBtnText={videoBtnText}
                variant="cs_heading_color"
              />
            </div>
          </div>

          <img src={imgUrl} alt="Hero" className="cs_hero_img" />

          <div className="cs_hero_info_wrap cs_shadow_1 cs_white_bg cs_radius_15">
            {infoList.map((item, index) => (
              <div className="cs_hero_info_col" key={index}>
                <div className="cs_hero_info d-flex align-items-center">
                  <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                    <img src={item.iconUrl} alt="Icon" />
                  </div>

                  <div className="cs_hero_info_right">
                    <h3 className="cs_hero_info_title cs_semibold">
                      {item.title}
                    </h3>

                    {item.type === "phone" ? (
                      <a
                        href={`tel:${item.subTitle.replace(/\D/g, "")}`}
                        className="cs_hero_info_subtitle cs_fs_20"
                      >
                        {item.subTitle}
                      </a>
                    ) : (
                      <p className="cs_hero_info_subtitle cs_fs_20">
                        {item.subTitle}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}

            <div className="cs_hero_info_col">
              <Link to={btnUrl} className="cs_btn cs_style_1">
                <span className="text-white">{btnText}</span>

                <i>
                  <img
                    src="/images/icons/arrow_white.svg"
                    alt="Arrow"
                  />
                  <img
                    src="/images/icons/arrow_white.svg"
                    alt="Arrow"
                  />
                </i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}